document.addEventListener("DOMContentLoaded", () => {
    const toggleInputs = document.querySelectorAll("[class*=toggle-input]");
    const prefersDarkScheme = window.matchMedia("(prefers-color-scheme: dark)").matches;
    const savedTheme = localStorage.getItem("theme");
    const currentTheme = savedTheme ?? (prefersDarkScheme ? "dark" : "light");

    const isDarkTheme = (theme) => theme === "dark";

    const setThemeClasses = (theme) => {
        const body = document.body;
        body.classList.remove("light-theme", "dark-theme");
        body.classList.add(`${theme}-theme`);
        document.documentElement.style.setProperty("color-scheme", theme);
    };

    const updateTextVisibility = (isDark) => {
        toggleInputs.forEach((input) => {
            const parent = input.parentElement;
            const lightText = parent?.querySelector(".toggle-text-light");
            const darkText = parent?.querySelector(".toggle-text-dark");

            lightText?.classList.toggle("toggle-text--visible", !isDark);
            darkText?.classList.toggle("toggle-text--visible", isDark);
        });
    };

    const updatetogglees = (isDark) => {
        toggleInputs.forEach((input) => {
            input.checked = isDark;
            input.setAttribute("aria-checked", isDark.toString());
        });
        updateTextVisibility(isDark);
    };

    const applyTheme = (theme) => {
        setThemeClasses(theme);
        localStorage.setItem("theme", theme);
        updatetogglees(isDarkTheme(theme));
    };

    const handletoggleChange = (input) => {
        const theme = input.checked ? "dark" : "light";
        applyTheme(theme);
    };

    toggleInputs.forEach((input) => {
        input.addEventListener("change", () => handletoggleChange(input));
        input.checked = isDarkTheme(currentTheme);
        input.setAttribute("aria-checked", isDarkTheme(currentTheme).toString());
    });

    applyTheme(currentTheme);
});
